import { storage } from '@visiba/std';
import type { Settings } from '@services/user_settings.service';

export const applicationLocalStorage = storage<{
	USER_SETTINGS: Settings;
}>({ type: 'local' });
